/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { GroupThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import { PasswordInput } from 'components/common/TextInput';
import Form from 'components/common/Form';
import { NavLink } from 'components/common/TextLink';
import Text from 'components/common/Text';
import { CancelSubmitFormControls } from '../../../common/FormControls/CancelUpdateFormControls';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { LocalText } from "../../common/LocalText";

const LoginPasswordTemplate = ({ submitForm, goBack, email, password, keepSignedIn, toggleKeepSignedIn, updatePassword, errorPhraseId, clearErrorMessage, goToForgotPassword, isPasswordGoodEnough, groupName, organizationName }) => (
  <GroupThemedContentPanelWithFullHeader isFixedWidth titlePhrase={{ id: 'login.titleGroups.text', values: { string1: <LocalText text={groupName}/> } }} subTitle={<LocalText text={organizationName}/>}>
    <WhiteCardWithWidePadding>
      <Form onSubmit={submitForm}>
        <PasswordInput
          value={password}
          onChange={updatePassword}
          label={<FormattedMessage id="loginPwd.password.field.label" />}
          autoFocus
          invalidHint={errorPhraseId ? <FormattedMessage id={errorPhraseId} /> : null}
          isInvalid={!!errorPhraseId}
          onFocus={clearErrorMessage}
        >
          <Text colorName="middle-gray" size="caption-1">
            <FormattedMessage id="loginPwd.email.field.label" /> {email}
          </Text>
        </PasswordInput>

        <section>
          <NavLink className="theme-group accent color" size="caption-1" to={goToForgotPassword}>
            <FormattedMessage id="loginPwd.forgotPassword.button.label" />
          </NavLink>
        </section>

        <CancelSubmitFormControls
          onCancel={goBack}
          onSubmit={submitForm}
          isSubmitDisabled={!isPasswordGoodEnough}
        />
      </Form>
    </WhiteCardWithWidePadding>
  </GroupThemedContentPanelWithFullHeader>
);

export default LoginPasswordTemplate;
